import { useLocation } from "react-router";

const textToSearch = "preview";

export const useIsStudioPreview = () => {
  const { search, pathname } = useLocation();
  return (
    search.toLowerCase().includes(textToSearch) ||
    pathname.toLowerCase().includes(textToSearch)
  );
};
